type AttachmentClassification = 'COMPLETION_DOCUMENTS' | 'COURSE_APPROVAL_DOCUMENTS';

type ProgramTemplateLike = {
  typeClassification?: string | null;
  requiredDocumentTypesFor: (classification: AttachmentClassification) => unknown[];
};

export function getAttachmentClassificationForType(typeClassification?: string | null) {
  if (typeClassification === 'TAS.ProgramType.2' || typeClassification === 'TAS.ProgramType.4.2') {
    return 'COMPLETION_DOCUMENTS';
  }

  if (typeClassification === 'TAS.ProgramType.3' || typeClassification === 'TAS.ProgramType.4.3') {
    return 'COURSE_APPROVAL_DOCUMENTS';
  }

  return null;
}

export function shouldDefaultToGuidedFlow(template?: ProgramTemplateLike | null) {
  if (!template) return false;

  const classification = getAttachmentClassificationForType(template.typeClassification);
  if (!classification) return false;

  return template.requiredDocumentTypesFor(classification).length > 0;
}

export function applicationRouteSuffixForTemplate(template?: ProgramTemplateLike | null) {
  return shouldDefaultToGuidedFlow(template) ? '-guided' : '';
}
